import { gql } from '@apollo/client';

import { theGraphAniftyMarketplaceV3Client } from '@/apis/theGraph/theGraphClients';

export const getAllPrimaryListingInfoByTokenID = async (
  tokenID: string | number
): Promise<{
  primaryListings: {
    askType: string;
    seller: string;
    tokenAmountSold: string | null;
    totalTokenAmount: string;
    currency: string;
    royaltyRecipients0: string;
    royaltyRecipients1: string | null;
    royaltyRecipients2: string | null;
    royaltyRecipients3: string | null;
    royaltyRecipients4: string | null;
    royalties0: string;
    royalties1: string | null;
    royalties2: string | null;
    royalties3: string | null;
    royalties4: string | null;
    askHash: string;
    tokenId: string;
    price: string;
    nonce: string;
    v: string;
    r: string;
    s: string;
    tokenCreationTimestamp: string | null;
    isCancelled: boolean;
    isCompleted: boolean;
    saleBlockNumber: BigInt;
    saleBlockTimestamp: BigInt;
  }[];
  primaryBuyHistories: {
    id: string;
    askHash: string;
    tokenId: string;
    tokenBuyAmount: string;
    paymentAmount: string;
    buyTimestamp: string;
    buyer: string;
  }[];
  primaryClaimHistories: {
    id: string;
    askHash: string;
    bidHash: string;
    claimer: string;
    tokenId: string;
    paymentAmount: string;
    platformCommissionAmount: string;
    claimTimestamp: string;
  }[];
}> => {
  const query = `
    {
      primaryListings(where: {tokenId: "${tokenID}"}) {
        askType
        seller
        tokenAmountSold
        totalTokenAmount
        currency
        royaltyRecipients0
        royaltyRecipients1
        royaltyRecipients2
        royaltyRecipients3
        royaltyRecipients4
        royalties0
        royalties1
        royalties2
        royalties3
        royalties4
        askHash
        tokenId
        price
        nonce
        v
        r
        s
        tokenCreationTimestamp
        isCancelled
        isCompleted
        saleBlockNumber
        saleBlockTimestamp
      }
      primaryBuyHistories(where: {tokenId: "${tokenID}"}) {
        id
        askHash
        tokenId
        tokenBuyAmount
        paymentAmount
        buyTimestamp
        buyer
      }
      primaryClaimHistories(where: {tokenId: "${tokenID}"}) {
        id
        askHash
        bidHash
        tokenId
        paymentAmount
        platformCommissionAmount
        claimTimestamp
      }
    }
  `;

  const response = await theGraphAniftyMarketplaceV3Client.query({
    query: gql(query),
  });

  return response.data;
};
